import React from "react";
import NewCommonServiceContent from "../../../common/NewCommonServices/NewCommonServiceContent";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import analytic1 from "../../../../assets/images/serviceImages/analyticPerformance1.webp"
import analytic2 from "../../../../assets/images/serviceImages/analyticPerformance2.webp"
import analytic3 from "../../../../assets/images/serviceImages/analyticPerformance3.webp"
const AnalyticWork = () => {
  return (
    <div>
      <NewCommonServiceContent>
        <div>
          <div className="h-full">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              className="flex justify-center items-center"
              pagination={{
                type: "bullets",
                el: ".pagination-progress",
                clickable: true,
              }}
              autoplay={true}
              spaceBetween={20}
              slidesPerView={1}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              loop
            >
              <SwiperSlide>
                <img
                  src={analytic1}
                  className="w-full rounded-[16px] object-cover"
                  alt=""
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={analytic2}
                  className="w-full rounded-[16px] object-cover"
                  alt=""
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={analytic3}
                  className="w-full rounded-[16px] object-cover"
                  alt=""
                />
              </SwiperSlide>
            </Swiper>
          </div>
          <div className="swiper-pagination pagination-progress w-full py-5"></div>
        </div>
      </NewCommonServiceContent>
    </div>
  );
};

export default AnalyticWork;
